// src/pages/RequisitesPage.tsx
// Публичная страница реквизитов и условий: реквизиты ИП Пилюгина,
// тарифы, порядок получения цифровой услуги, ссылка на публичную оферту.
import React from 'react';
import styled from 'styled-components';
import Footer from '../components/common/Footer';
import AddressText from '../components/common/AddressText';
import { useLang } from '../context/LangContext';
import { OFFER_URL } from '../constants';

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background};
`;

const Main = styled.main`
  flex: 1;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 32px 24px;
`;

const Section = styled.section`
  background: ${({ theme }) => theme.colors.cardBackground};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: 20px 24px;
  margin-bottom: 16px;
  box-shadow: ${({ theme }) => theme.shadows.sm};
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.colors.text};
  font-size: 1.6rem;
  margin: 0 0 16px;
`;

const H2 = styled.h2`
  color: ${({ theme }) => theme.colors.text};
  font-size: 1.15rem;
  margin: 0 0 10px;
`;

const P = styled.p`
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.5;
  margin: 0 0 8px;
  text-align: justify;
`;

const List = styled.ul`
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.5;
  margin: 0;
  padding-left: 20px;
`;

const Link = styled.a`
  color: ${({ theme }) => theme.colors.primary};
`;

const RequisitesPage: React.FC = () => {
  const { t } = useLang();

  return (
    <Page>
      <Main>
        <Title>{t('requisitesTitle')}</Title>

        <Section>
          <P>{t('requisitesIntro1')}</P>
          <P>{t('requisitesIntro2')}</P>
          <P>{t('requisitesIntro3')}</P>
          <P>
            <AddressText text={t('requisitesIntro4')} />
          </P>
        </Section>

        <Section>
          <H2>{t('requisitesPricesTitle')}</H2>
          <List>
            <li>{t('requisitesPriceIndividual')}</li>
            <li>{t('requisitesPriceComparison')}</li>
          </List>
          <P style={{ marginTop: 8, fontSize: '0.9rem' }}>
            <AddressText text={t('requisitesPriceInfo')} />
          </P>
        </Section>

        <Section>
          <H2>{t('requisitesOfferTitle')}</H2>
          <P>
            {t('requisitesOfferText')}{' '}
            <Link href={OFFER_URL} target="_blank" rel="noopener noreferrer">
              psydecrypt.online
            </Link>
          </P>
        </Section>

        <Section>
          <H2>{t('requisitesRequisitesTitle')}</H2>
          <List>
            <li>{t('requisitesName')}</li>
            <li>{t('requisitesInn')}</li>
            <li>{t('requisitesOgrnip')}</li>
            <li>{t('requisitesAccount')}</li>
            <li>{t('requisitesBank')}</li>
            <li>{t('requisitesBik')}</li>
            <li>{t('requisitesKor')}</li>
            <li>{t('requisitesBankInn')}</li>
            <li>{t('requisitesBankKpp')}</li>
          </List>
        </Section>
      </Main>
      <Footer />
    </Page>
  );
};

export default RequisitesPage;